export default "__VITE_ASSET__BZ83G8hR__"